import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconTrending2"><Path fillRule="evenodd" clipRule="evenodd" d="M13.1734 22.798L18.2148 6.66554L20.5528 11.3417L22.3417 10.4472L17.7853 1.33452L12.8267 17.2021L8.12235 6.85252L4.95554 12.1305L3.27738 9.61328L1.61328 10.7227L5.04452 15.8695L7.87772 11.1475L13.1734 22.798Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTrending2;
